import Nav from "../Nav";
import SkeletonCard from "../SkeletonCard";
import { useAuthContext } from "../context/AuthContext";
import { useFavourite } from "../context/FavouriteContext";
import { FilterNews } from "../news/FilterNews";

function Favorites() {
  const { currentUser } = useAuthContext();
  const { favourites, isLoading } = useFavourite();

  return (
    <>
      <Nav />

      {!currentUser && <div>Login to use this</div>}

      {currentUser && isLoading && (
        <div className="main_container">
          {Array.from({ length: 8 }).map((_, i) => (
            <SkeletonCard key={i} />
          ))}
        </div>
      )}

      {currentUser && !isLoading && <FilterNews />}
    </>
  );
}

export default Favorites;